module.exports = __webpack_public_path__ + "img/coupon_five.ee86f2da.webp";